import styled from 'styled-components'

const NavbarWrapper = styled.nav`
  padding: 12px 22px;
  display: block;

  img {
    width: 100%;
  }

  .navbar-brand {
    width: 96px;
  }
`

export default NavbarWrapper
